import React, { Component } from 'react';
import { connect } from 'react-redux';

import liendirect from './../../../assets/images/svg/049-family.svg';
// import autres from './../../../assets/images/svg/051-parents.svg';

class deleteUser extends Component {
	render() {
		return (
			<div className="modal fade px-0" id="deleteUser" aria-labelledby="deleteUserLabel" aria-hidden="true">
				<div className="modal-dialog px-2">
					<div className="modal-content">
						<header className="modal-header">
							<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">Delete user</h1>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="deleteUserLabel">Supprimer l'utilisateur</div>
									<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
										<i className="eva eva-close fs-4"></i>
									</button>
								</div>
							</div>
						</header>
						<div className="modal-body scroll-default pt-0">
							<p className="h5 lh-copy mb-gutter">Confirme que vous souhaitez supprimer l'utilisateur ?</p>
							<div className="accordion mt-gutter" id="accordionUserDetail">
								<div className="card mb-4">
									<div className="card-header p-0" id="headingUserDetail" role="button">
										<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target="#accordionUserDonnes" aria-expanded="true" aria-controls="accordionUserDonnes">
											<h2 className="h2 font-weight-bolder my-auto">Clients</h2>
											<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1" name="refPrincipal"><i className="eva eva-arrow-ios-upward-outline"></i></button>
										</div>
										<hr className="mt-2 mb-0"/>
									</div>
									<div className="collapse show" id="accordionUserDonnes" aria-labelledby="headingUserDetail" data-parent="#accordionUserDetail">
										<div className="card alert-primary mt-3">
											<div className="card-header px-3 pt-3 pb-0">
												<div className="flex-row align-items-center justify-content-between">
													<h2 className="h1 font-weight-bolder my-auto">Vallis Lajoie</h2>
													<button type="button" className="btn btn-dim py-2 px-3 ml-auto text-uppercase font-weight-demi fs-3 my-auto" disabled name="refPrincipal">Actif depuis 15/05/2020</button>
												</div>
											</div>
											<div className="card-body text-body p-3">
												<div className="row g-2">
													<div className="col flex-column align-items-start">
														<div className="h6 font-weight-demi">Cycle de la vie</div>
														<p className="h5 lh-copy my-auto">17/09/1987</p>
													</div>
													<div className="col flex-column align-items-start">
														<div className="h6 font-weight-demi">Numéro de processus</div>
														<p className="h5 lh-copy my-auto">000001736</p>
													</div>
													<div className="col flex-column align-items-start">
														<div className="h6 font-weight-demi">Paiement</div>
														<p className="h5 lh-copy my-auto">Reglé en interne</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-header p-0" id="headingUserRef" role="button">
										<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target="#accordionUserRef" aria-expanded="true" aria-controls="accordionUserRef">
											<h2 className="h2 font-weight-bolder my-auto">Mandataires</h2>
											<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1" name="refPrincipal"><i className="eva eva-arrow-ios-upward-outline"></i></button>
										</div>
										<hr className="mt-2 mb-0" />
									</div>
									<div className="collapse show" id="accordionUserRef" aria-labelledby="headingUserRef" data-parent="#accordionUserDetail">
										<div className="card border border-dim mt-3">
											<div className="card-header px-3 pt-3 pb-0">
												<div className="flex-row align-items-center justify-content-between">
													<h2 className="h4 text-secondary text-uppercase font-weight-bolder my-auto">autre mandataire</h2>
													<button type="button" className="btn btn-dim py-2 px-3 ml-auto text-uppercase font-weight-demi fs-3 my-auto" disabled name="refPrincipal">Actif depuis 15/05/2020</button>
												</div>
												<hr className="mb-0" />
											</div>
											<div className="card-body p-3">
												<div className="row gx-3">
													<div className="col h-inherit border-right border-none border-lg-dim">
														<h4 className="h6 font-weight-bolder">Monsieur</h4>
														<h3 className="h3 font-weight-regular mb-4">data.lastName + firstName</h3>
														<div className="card text-capitalize flex-row align-items-center justify-content-between mb-3">
															<img className="img-fluid my-auto mb-2 h-5 py-1" src={liendirect} alt={"lien familial direct"} />
															<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">lien familial direct</h2>
														</div>
														<div className="flex-row align-items-start mb-3">
															<i className="eva lh-copy eva-calendar-outline mr-2 o-50"></i>
															<p className="h5 lh-copy my-auto">2 mars 1960</p>
														</div>
														<div className="flex-row align-items-start mb-3">
															<i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
															<p className="h5 lh-copy my-auto">71, rue de Raymond Poincaré <br />11100 NARBONNE, France</p>
														</div>
														<div className="flex-row align-items-start">
															<i className="eva lh-copy eva-email-outline mr-2 o-50"></i>
															<p className="h5 lh-copy my-auto">theundertaker@rhyta.com </p>
														</div>
													</div>
													<div className="col h-inherit my-auto">
														<div className="d-flex flex-column align-items-start mb-4">
															<div className="h6 font-weight-demi">Attaché au numéro de dossier</div>
															<p className="h5 lh-copy my-auto">240220201040</p>
														</div>
														<div className="d-flex flex-column align-items-start mb-4">
															<div className="h6 font-weight-demi">Type du dossier</div>
															<p className="h5 lh-copy my-auto">Anticipa</p>
														</div>
														<div className="d-flex flex-column align-items-start">
															<div className="h6 font-weight-demi">Nom du client</div>
															<p className="h5 lh-copy my-auto">Marmion de la Ronde</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="card border border-dim mt-gutter">
								<div className="card-header px-3 pt-3 pb-0">
									<div className="flex-row align-items-center justify-content-between">
										<h2 className="h4 text-secondary text-uppercase font-weight-bolder my-auto">Referent principal</h2>
										<button type="button" className="btn btn-dim py-2 px-3 ml-auto text-uppercase font-weight-demi fs-3 my-auto" disabled name="refPrincipal">Actif depuis 15/05/2020</button>
									</div>
									<hr className="mb-0" />
								</div>
								<div className="card-body p-3">
									<div className="row gx-3">
										<div className="col h-inherit border-right border-none border-lg-dim">
											<h4 className="h6 font-weight-bolder">Monsieur</h4>
											<h3 className="h3 font-weight-regular mb-4">data.lastName + firstName</h3>
											<div className="card text-capitalize flex-row align-items-center justify-content-between mb-3">
												<img className="img-fluid my-auto mb-2 h-5 py-1" src={liendirect} alt={"lien familial direct"} />
												<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">lien familial direct</h2>
											</div>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-calendar-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">2 mars 1960</p>
											</div>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">71, rue de Raymond Poincaré <br />11100 NARBONNE, France</p>
											</div>
											<div className="flex-row align-items-start">
												<i className="eva lh-copy eva-email-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">theundertaker@rhyta.com </p>
											</div>
										</div>
										<div className="col h-inherit my-auto">
											<div className="d-flex flex-column align-items-start mb-4">
												<div className="h6 font-weight-demi">Attaché au numéro de dossier</div>
												<p className="h5 lh-copy my-auto">240220201040</p>
											</div>
											<div className="d-flex flex-column align-items-start mb-4">
												<div className="h6 font-weight-demi">Type du dossier</div>
												<p className="h5 lh-copy my-auto">Facilita</p>
											</div>
											<div className="d-flex flex-column align-items-start">
												<div className="h6 font-weight-demi">Nom du client</div>
												<p className="h5 lh-copy my-auto">Marmion de la Ronde</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer pt-0">
							<button type="button" className="btn btn-faded" data-dismiss="modal">Fermer</button>
							<button type="button" className="btn btn-danger" data-dismiss="modal">Supprimer</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => ({
	example: state.example,
});
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(deleteUser);